(function ($) {
    var $ = jQuery = $;

    // On DOM ready
    $(function () {

        $('.site-nav__dropdown-heading.has-children').click(function(e) {
            e.preventDefault();

            var $this = $(this);

            if ($this.next().hasClass('show_accordion_content')) {
                // Clicked on opened
                $this.next().removeClass('show_accordion_content');
                $this.next().slideUp(350);
                $this.toggleClass("expanded");

            } else {
                // Close if any is already opened
                $this.parent().parent().find('.site-nav__submenu').removeClass('show');
                $this.parent().parent().find('.show_accordion_content').removeClass('show_accordion_content');
                $this.parent().parent().find('.expanded').removeClass('expanded');
                $this.parent().parent().find('.site-nav__submenu').slideUp(350);

                // Open clicked
                $this.toggleClass("expanded");
                $this.next().toggleClass('show_accordion_content');
                $this.next().slideToggle(350);
            }
        });
    });
    //
})(theme.jQuery);